function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "25.17 36.94 447.38 427.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.63,37.1c-54,2.8-70.8,49.74-77.55,72.4-11.05,37.1-18.69,55.42-46.46,57.28-29,1.95-39.42-22.92-70-48.38C133.05,88.75,75.41,90.76,40,159.26c-39.67,76.8,4.76,154.41,79.69,211.6,42.83,32.7,85.88,39,149.15,25.51,110.3-23.53,180.49-110.83,197.59-211.57C476.15,127.63,451.62,32.48,362.63,37.1Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.63,37.1c-54,2.8-70.8,49.74-77.55,72.4-11.05,37.1-18.69,55.42-46.46,57.28-29,1.95-39.42-22.92-70-48.38C133.05,88.75,75.41,90.76,40,159.26c-39.67,76.8,4.76,154.41,79.69,211.6,42.83,32.7,85.88,39,149.15,25.51,110.3-23.53,180.49-110.83,197.59-211.57C476.15,127.63,451.62,32.48,362.63,37.1Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.28,
    y: 398.94,
    width: 47.75,
    height: 65.18,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.28,
    y: 398.94,
    width: 47.75,
    height: 65.18,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.31,
    y: 308.41,
    width: 47.75,
    height: 155.71,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.31,
    y: 308.41,
    width: 47.75,
    height: 155.71,
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.39,
    y: 272.27,
    width: 47.75,
    height: 191.85,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.39,
    y: 272.27,
    width: 47.75,
    height: 191.85,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.47,
    y: 209.08,
    width: 47.75,
    height: 255.04,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.47,
    y: 209.08,
    width: 47.75,
    height: 255.04,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "472.55 132.82 454.65 91.14 412.97 109.03 419.03 123.14 436.63 115.59 406.46 191.16 361.65 247.07 293.45 268.96 292.8 269.17 230.07 302.51 187.45 318.7 174.67 384.61 142.35 384.61 115.5 447.74 32.07 447.74 32.07 463.1 125.65 463.1 152.51 399.97 187.33 399.97 200.89 330.01 236.42 316.52 298.79 283.37 370.74 260.28 419.87 198.98 450.89 121.28 458.44 138.87 472.55 132.82",
    style: {
      fill: "#10A7D0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234,291.12l-.28,4.62s-4,2.75-7.13,4.68c-2,1.23-3.82,1.54-3.58,2.51.6,2.48,9.22-.32,13.53-1.36s10-1,5.83-4.93a15.73,15.73,0,0,1-1.25-1.52l.13-4.71Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.38,255.83s1.21,4.84,1,6.47a13.14,13.14,0,0,0,.15,5c.83,2.79,2.59,1.68,6.43.74,4.08-1,7.41-1.28,7.09-3.17s-5.43-2.26-6.49-3.74-1.68-6.92-1.68-6.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,219.6s-12.88,27.18-14.78,39.58-.76,33.9-.76,33.9,3.34,2,9,.08c0,0,2.44-31.14,4.28-34.74s15.67-23.3,18.2-24.44,16.21,8.17,18.17,11.55,6.6,15.25,6.6,15.25,3.59,1.76,8.21-2.35c0,0-.89-15.23-5.16-21.21s-17.65-20.64-17.65-20.64Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.72,246.36c-4.81,1.52-9.2-4.26-11.75-6.8s-7.38-10.14-10.29-8.42-5,1.25-10,.13-12.21,22-15.87,25-2.07.87-4.06,18.75c-1.4,12.58-4.8,15.71-6.69,16.46,0,1,.08,1.64.08,1.64s3.34,2,9,.08c0,0,2.44-31.14,4.28-34.74s15.67-23.3,18.2-24.44,16.21,8.17,18.17,11.55,6.6,15.25,6.6,15.25,3.59,1.76,8.21-2.35a79.44,79.44,0,0,0-2.49-15.15A4.8,4.8,0,0,1,291.72,246.36Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,257.79a11.14,11.14,0,0,0,.46,5.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.81,241.37s-3.09.74-1.1,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.34,227.71s9.3,3.53,8.38,4.81-5.57.47-5.57.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2,230.73a22.36,22.36,0,0,0,5.38-3.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.23,243.18s-2.08,2.26-4.15,1.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.74,259.3s-3.39.69-3.8,1.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.64,190.77l-5.35,4.71a25.19,25.19,0,0,0-8.09,4.25c-4.62,3.4-16.63,12.49-16.63,12.49a24.57,24.57,0,0,1-4.39,1c-2,.22-4.15,1.72-3.72,2.4s2.28-.73,2.73-.66-.42,4.4.17,5.4,1.5-.37,1.5-.37a1.38,1.38,0,0,0,2.09-.42s1.38.28,1.62-.92c0,0,1,.46,1.31-.75a14.27,14.27,0,0,1,.71-2.11s22.06-10,25.29-14.05c0,0,2.82-1,3.3-2.29l4.2-3.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.88,218.41s.85-.12,1,.28,1-.68,1.47-.45,1.11-1.23,1.73-.86",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.51,170c-1.64,1.6-10.35,22.42-16.46,20.4a90.43,90.43,0,0,1-12.16-5.26l3.12-8.09,9.39,5s.18-2.53,12.29-13.37c0,0-1.43-4-1.24-5.63s-.22-3.36.71-3.33.69,2.86.69,2.86l.21.87s2.16.19,3-1.07a6.46,6.46,0,0,0,1.22-2.85c.14-.77.93-2.14,1.31-.85,0,0,1-.44,1,1a18.61,18.61,0,0,1-.09,2.32s.93-1.87,1.28-1.49-.7,2.54-.7,2.54,1.36-1.19,1.48-.69-1.39,1.85-1.71,2.72A15.07,15.07,0,0,1,306.51,170Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.59,172.65c-4.14.79-17.23,3.49-15.94,8.09,1.21,4.29,7.9,24.84,6.51,37a2.36,2.36,0,0,0,2.25,2.64A94.29,94.29,0,0,0,275,217.6a5.24,5.24,0,0,0,3.91-5.86c-.94-6.16-2.31-17.38-1.43-26.17C278.8,172.8,278.09,168.37,255.59,172.65Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.74,175.69a5.71,5.71,0,0,0-1.25,7.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,194.66a44.52,44.52,0,0,0,24.78,17.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.63,216.08a47.54,47.54,0,0,0,12.77-.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.57,179.3l-15.18,10.86s3.42,8.3,7.06,8.82l11.44-7.45",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.57,173.18s8,1.41,18.39,7.31c0,0,0,6.33-4,10.47l-10.33-4.85",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.8,179.75l2.08,4.14-.58,11.38s-.09,9.76,3.89,24.33l3,1.3,2.26-1.78s-4.15-20.32-4.56-24.17l-2.26-11.39,1.64-4.18-3.41.42Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.78,174.58c-1.58.31-4.46.89-7.35,1.74a13.61,13.61,0,0,0-.21,6.51A4.66,4.66,0,0,1,253,181c4.43-3.09,7.67-.8,7.67-.8a65.18,65.18,0,0,0-1.13-6.42C258.07,174,256.5,174.26,254.78,174.58Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,170.29s1.08,3.38,2.26,3.64c0,0-1.52,5.95-7.19,4.8s1.58-6.51,1.58-6.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.13,170s1.19,2.7,2.94,2.31c0,0-1.33-4.7-.71-7.55s-1.41-10.06-8.17-8.08a14,14,0,0,0-8.52,2.59c-3.89,2.93-4.55.78-4.55.78s-.8,3.49,2.95,2.64c0,0-1,2-2.73,1.52,0,0,1.3,1.79,3,.92,0,0-1.13,1.56-.15,2.62,0,0,4.63-3.71,7.35-3.06S255.13,170,255.13,170Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.58,169s1.79,8.5,7.32,11.39c3.7,1.93,7.5-7.62,7.44-8.92a3.27,3.27,0,0,0,1.82-2.81c.09-2.06-1.41-2.56-2.63-1.6,0,0-.5,1.44-1.14,1.53s-.49-3.64-1.23-4-2.49-.52-3.06-2-3,.6-6.15,1S241,166.89,241.58,169Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,170.55a4.87,4.87,0,0,1-1.22,3.63c-.83.91,2.36.31,2.6.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.4,170.51c.11.43,0,.82-.14.86s-.42-.27-.52-.7,0-.83.14-.87S243.3,170.07,243.4,170.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.66,169.47c.1.44,0,.82-.14.87s-.42-.27-.53-.71,0-.82.14-.87S247.55,169,247.66,169.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.46,174.14c.12,1.2-2.75,2-2.75,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.58,169a2.67,2.67,0,0,1,2.63.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.85,168.69s.67-2.58,2.15-1.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.1,165a2.4,2.4,0,0,1,.57,2.34",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.24,184.85a127.81,127.81,0,0,0-5.91-11.56c-2.27-3.54-16.2-2-21.71-.36s-8.75,21.72-9.82,28.26,6.25,34.62,6.25,34.62c-2.59,3.57-10.05,2.59-10.05,2.59s-7.77-22.36-9.39-34,5.4-40.51,5.4-40.51l21.78-5.58s15.82-.3,22.89.08c10.47.55,7.34,24.34,7.34,24.34S407.4,184.85,401.24,184.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.83,235.49s2.43,4.86-1.22,6.8-5.16,4.78-3.18,4.78h12.42c2.19,0,4.38-1.13,2.43-4.82-.39-.73-2.67-8.47-2.67-8.47Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.68,180.71s.81,5.35,1,8.43,2.27,4.86,4.7,3.73,14.26-9.4,13.61-11.19-3.24.33-6.32,1a27.26,27.26,0,0,1-5,.64l-.81-4.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.37,202.75s.87,3.4,2.81,4.54",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.8,171.8s8.26-2,8.23-.81-5,3.08-5.37,4",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.63,170.63s5.19-2.2,5.19-3.43",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,182.7a17.33,17.33,0,0,1-6.78,2.15",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.74,236.67c-2.13,1.76-5.76,1.91-7.78,1.84",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.54,114s2.75-10.21-2.92-12.81c0,0-3.81-3.89-11,0s-4.45,6.46-2.92,5.54c0,0-3.48,3.13-2.59,4.11s2.59-.73,2.59-.73a9,9,0,0,0,1.3,5c1.46,2,8.42,1.22,8.42,1.22l5.36-1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.61,167.15a4.31,4.31,0,0,1-4-3.5c-.84-4.31-2.48-12.39-4.27-19.56-2.6-10.37-12.38-20.33,13.29-24.63,25.13-4.22,19.44,7.13,19.12,13.93-.27,5.57-1.62,16,.56,21.29a4.35,4.35,0,0,1-1.5,5.31C375.23,163.1,366.63,167.71,356.61,167.15Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.26,136.25a30,30,0,0,0,24.13,12.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.33,155.87l21.58.19a50.33,50.33,0,0,1-20.85,4.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.76,124.64s1,4.78,2,5.27c0,0-2.43,14.74-.48,27.3l.83,4.78,3.71,1.87,3.07-3.57s-.72-3.34-1-4.45c-1.41-6.43-4.14-18.72-4-26,0,0,3.39-2.68,3.15-5Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.73,125.82l6.51-5.27a57.35,57.35,0,0,0,7.68-2.77c5-2.12,17.38-8.49,17.38-8.49a23.43,23.43,0,0,1,4.3,0c1.86.23,4.21-.67,4-1.4s-2.27.17-2.67,0,1.36-4,1-5-1.45,0-1.45,0a1.32,1.32,0,0,0-2-.07s-1.22-.57-1.7.49a.87.87,0,0,0-1.38.41,14.88,14.88,0,0,1-1.12,1.79s-21.86,5-25.74,8l-10.06,5.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.81,142.66l-7.24,4a54.94,54.94,0,0,1-6.35,5.13c-4.42,3.19-16.28,10.45-16.28,10.45a23.21,23.21,0,0,0-2.22,3.68c-.77,1.71-2.75,3.25-3.25,2.67s1.32-1.85,1.4-2.28-4.11-.9-4.84-1.73.76-1.24.76-1.24a1.32,1.32,0,0,1,1-1.77s.15-1.34,1.3-1.2c0,0-.13-1,1.07-1a14.8,14.8,0,0,0,2.11,0s15.62-16.08,20.21-17.84l9.19-5.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.63,119.29s-1.11,8.19.38,9.89c0,0,1.56-4.86,5.7-1.78,0,0,6-3.65,6.88,1.21,0,0,2.11-5.86,2-10.26l-13.44-.16Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.71,124.17l-14.93,13.64s4.4,6.81,7.47,8.27,8.41-8.43,8.41-8.43",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.86,118.86l16.75-5.1s2.91,6.51,1.62,10.56-13.78,4.86-13.78,4.86",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,115.08s1.62,11,6.16,11,7.94-5.61,8.26-6.94a17.64,17.64,0,0,0,.41-2s.4.48,1.21.08,1.06-5.51.49-5.59a12.16,12.16,0,0,0-1.86,0s0,2.51-.65,2.43-.49-3.49-.89-3.89-1.95.08-3.08-.73-2.19,1-5,1.13-3.21-1.7-4-.81S355.87,114.67,355,115.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.35,116.43a12.13,12.13,0,0,0-.56,3.33c.16.83,2.22-.14,2.29.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.08,122.05a3.6,3.6,0,0,0,2.72-1.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.57,116.91c0,.41-.18.74-.4.74s-.41-.33-.41-.74.19-.74.41-.74S357.57,116.5,357.57,116.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.47,116.68c0,.41-.18.74-.4.74s-.41-.33-.41-.74.18-.74.41-.74S362.47,116.27,362.47,116.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,114.19s1-1.22,2.37,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.73,115.24s1.77-1.78,2.67-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.14,171.81l6.81.27",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.46,159.31a9.83,9.83,0,0,1,2.78,9.13",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.59,252.45l6.23-5.86a58.89,58.89,0,0,1,5.16-6.87c3.69-4.39,13.93-14.85,13.93-14.85a25.15,25.15,0,0,0,1.32-4.33c.34-1.95,2-4,2.63-3.56s-.87,2.23-.84,2.69,4.43-.14,5.38.52-.45,1.46-.45,1.46a1.38,1.38,0,0,1-.56,2.06s.19,1.4-1,1.56c0,0,.4,1-.84,1.26a15,15,0,0,0-2.14.58s-11.81,20.43-16,23.4l-7.78,9.3Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.76,261.8s8.65-8.75,12.9-12c0,0,5.07,5.87,4.89,11,0,0-6.72,7.77-10.06,8.51",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.81,311.17a14.34,14.34,0,0,1,5,5.66c1.35,3,0,4.26,2,6.11,2.29,2.11,16-8.87,15.35-10.74s-3.41.34-6.65,1a28.54,28.54,0,0,1-5.29.68l-3.93-6.65Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,302.5s8.39-3.54,11.46-11.9c0,0-2.39,8.18,14,24.22,0,0,5-.68,6.85-5.12,0,0-14.42-33.6-19.51-33.43s-24,16.26-24,16.26S137.38,304,146.8,302.5Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.59,296.18c-1.59-4.09-.79-16.9-3.36-9.87s-8.67,6.3-8.67,6.3l-2.06,2.93,2.48,5.15a21.38,21.38,0,0,0,8.28-10.09s-2.39,8.18,14,24.22a10,10,0,0,0,5.3-2.77C172.12,313.61,163.19,300.26,161.59,296.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.6,284.11s-1.11.61-.8,4.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,372.39l.64,4.1c4.73,4.86,10.23,3.19,10.49,5.37s-7.42,1.79-10.36,1.79-8.06,1-9.09-.77c-.51-.89.93-3.19,1.47-5.27a9.83,9.83,0,0,0,.2-3.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.56,239.08s4.27-3.58,2.73-5-3.44,1.15-3.44,1.15,1.52-4.6-.65-5.24-2.43,4-2.43,4-.13-4.08-2.31-4,0,2.86-3.71,5.3-8.31,5.38-4.73,9.47c0,0-2.17,2.56,2.18,5.37s5.43,3.75,6,6.93l5-4.75.65-9.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8,248l6.66-5.35a58.56,58.56,0,0,1,5.69-6.45c4-4.09,15-13.73,15-13.73a25,25,0,0,0,1.65-4.21c.49-1.91,2.28-3.86,2.9-3.34s-1,2.16-1,2.61,4.42.21,5.32.94-.57,1.42-.57,1.42a1.38,1.38,0,0,1-.71,2s.08,1.41-1.14,1.48c0,0,.32,1-.94,1.19a14.42,14.42,0,0,0-2.18.41S176.12,244.39,171.67,247l-8.48,8.66Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,297.25s-3.58,7.33,4.78,14.67,23.71,24.22,24.73,29.68,5.8,33.61,5.8,33.61,5.46,1.53,9-1.2c0,0,.34-27.08-2.56-37.76s-13.49-23.79-16.54-32.35a32.11,32.11,0,0,1-.69-5.46Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.75,339.21c.5-2.84-15.52-25.3-20.61-25.3-2.06,0-5.49-1-8.34-2,8.36,7.34,23.69,24.21,24.71,29.66s5.8,33.61,5.8,33.61a14.41,14.41,0,0,0,4.06.41C160.14,374.59,158.24,342.05,158.75,339.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.6,337.68a3.88,3.88,0,0,0-4.07,1.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.27,239.46l2.3,3.72s3.31.51,3.77,1.53-1.85,1.66-1.85,1.66,3.2,3.71,2.69,5-5,3.71-5,3.71l-9.85.61s1.66-2.78.89-4.7c0,0-3.71.23-3.32-3.41s2.94-.81,2.94-.81a1.67,1.67,0,0,0,.77-2c-.39-1.53.89-2.17,1-3.45S149,235.75,151.27,239.46Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.42,243.2c.27.46.27,1,0,1.1s-.68-.1-.95-.56-.27-1,0-1.1S152.16,242.75,152.42,243.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.76,241.26s-3.2-1.41-3.33,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.91,259v-4s18-4,15.67,2.43L154.72,259Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.63,300.45A107.14,107.14,0,0,1,133.36,267c8.19-16.63,25.53-11.24,26.1-6.35,1,8.68-4,16.53-6.52,27.06-1.67,6.92-.72,12.51-2.95,12.81C144.36,301.26,123.63,300.45,123.63,300.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.2,256.86S156.77,248,161,244.71c0,0,5.12,5.83,5,11,0,0-6.65,7.84-10,8.6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49,268.63a79.5,79.5,0,0,1-18.66,18.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.09,281.7a42.72,42.72,0,0,1-16.23,14.92c.1-.2.19-.4.29-.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.41,302.39a5.94,5.94,0,0,0,1.18-2.68c.09-1.28-.28-8.72.63-8.5s.86,3.5.86,3.5,2.5-6.75,3-6.5-.12,2.24-.12,2.24,1.24-2.24,1.7-2-.59,3.26-.59,3.26,1.33-1.64,1.79-1.45-1.17,4-1.17,4,1.71-2,2.19-1.6-1.77,2.83-2.17,4.26a13.23,13.23,0,0,1-3,4.93l-.74,3.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.21,333.67s3.36-2.95,14.46-4.76a7.6,7.6,0,0,0,4.17-2.1c2.49-2.47,6-5.74,7.94-7.81,2.69-2.95,3.48-4.66,10-18.59a6.5,6.5,0,0,1,5.48,5.6s-5.75,13.81-8.93,18.25-17,14.6-17,14.6",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.99 322.85 84.25 314.11 92.28 317.44 91.49 324.71 81.99 322.85",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.77,320.64s3-5.49,3-6.81c0,0,3.61-1.84,3-4.75s-1.09-4.72-1.09-4.72l1-1.67s3.48-.76,2.42-3-6.16.88-9.62,1.49-8.16,2.11-6.64,5.61l-.34.91S71.19,315.16,82.77,320.64Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.09,325.93l1.21-4.65s7.8.21,11.51,3.62v3.68Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.39,316.4s3.27,4.88,8.07,3.09c3.39-1.28.47-6,.47-6s1.63-.75,1.56-1.68-2.74-2.93-2.74-2.93-.48-3.1-1.39-3.72l-3.66-2.45s-4-.14-4.14.6S87,306.6,87,306.6s.26,5.44-.43,5.79-2.52-.18-2.52-.18-3.54-1.41-2.94,1.65S85,317.89,86.39,316.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.72,309.38c.17.46.15.9,0,1s-.5-.24-.67-.7-.16-.9,0-1S92.54,308.92,92.72,309.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.07,307.43a1.34,1.34,0,0,1,1.82-.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,315.17s1.27.47,1.88-.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65,436.06l.64,4.1c4.73,4.86,10.23,3.2,10.49,5.37s-7.42,1.79-10.37,1.79-8.06,1-9.08-.76c-.51-.9.93-3.2,1.47-5.27a9.76,9.76,0,0,0,.19-3.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,436.06l-2.43,4.1c4.73,4.86,10.23,3.2,10.49,5.37s-7.42,1.79-10.36,1.79-8.06,1-9.09-.76c-.51-.9,3.71-9.2,3.71-9.2Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,364.1s.68,5.41,0,7.48c0,0,10.07,22.2,10.41,32.1.06,1.81-3.59,34.6-3.59,34.6s-2.9,2.36-8.53,0c0,0-1-23.52.35-32.9,0,0-7-17-9-22.25s-2.81-16.29-2.81-16.29Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.58,383.13c2,5.21,9,22.25,9,22.25-1.37,9.38-.35,32.9-.35,32.9,5.63,2.36,8.53,0,8.53,0s.1-.83.25-2.22h0s-6.78,4.54-7.48-2.8,2.41-23,2.77-27.57-7.44-13.19-5.12-19.54,2.76-22,2.76-22l-13.21,2.74S89.53,377.92,91.58,383.13Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.23,404.05s1.35,3.1,3.54,3.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.62,378.73a25.93,25.93,0,0,1-5.89,7.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.62,366.06s-1.28,11.52-7.17,19.45-11.26,23.28-15.86,26.87-18.43,25.84-18.43,25.84-6,4.29-9.72-.51c0,0,11.52-23.29,18.68-32.24,0,0,7.16-17.3,9.47-22.34,0,0-1.54-6.83,3.58-15.79Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.66,437.53c-.34-6.31,9.89-18.94,17-33.48s16.4-16.84,11.45-17.9a7,7,0,0,1-4.69-4,8.49,8.49,0,0,0,.14,1c-2.31,5-9.47,22.34-9.47,22.34-7.16,8.95-18.68,32.24-18.68,32.24A5.44,5.44,0,0,0,53,439.9,2.94,2.94,0,0,0,53.66,437.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.91,406.36s-.77,3.71,1.66,5.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.68,370.57a3.36,3.36,0,0,1-3-4,8.55,8.55,0,0,0,0-3.58c-2.06-10.31-8.15-29.07-4.13-34.54,5.63-7.68,17.14-3.84,21,1.79,3.49,5.12,7.83,25.69,7.82,34.95a3.37,3.37,0,0,1-2.37,3.19A50.88,50.88,0,0,1,82.68,370.57Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.57,301a6,6,0,0,0,1.54-2.5c.26-1.25.91-8.67,1.78-8.33s.38,3.58.38,3.58,3.38-6.35,3.81-6-.43,2.2-.43,2.2,1.54-2,2-1.79-1,3.15-1,3.15,1.54-1.45,2-1.19-1.7,3.84-1.7,3.84,2-1.71,2.39-1.28-2.14,2.55-2.73,3.92a13.26,13.26,0,0,1-3.6,4.48l-1.25,3.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.46,326.91s3.74-2.46,15-2.74a7.66,7.66,0,0,0,4.42-1.52c2.8-2.11,6.77-4.86,8.92-6.65,3.07-2.56,4.09-4.15,12.45-17.06a6.5,6.5,0,0,1,4.68,6.29s-7.58,12.9-11.33,16.86-18.85,12.16-18.85,12.16",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.91,335.71a20.47,20.47,0,0,1-8.09,9.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.78,354l-2.19,11.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.82,406.9a11.3,11.3,0,0,0,5.38,7.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,337.59c-.37,2.19-.73,4.38-1.1,6.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg18);
export default __webpack_public_path__ + "static/media/img18.9e26eb9819cc67c9d4b231958e88f8ef.svg";
export { ForwardRef as ReactComponent };